import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: false,name: 'invNumber'})

export class InvoiceNumberPipe implements PipeTransform {
  transform(value: number): string {
    if (value != null) {
      const amountOfDigits: number = 6;
      const tempString: string = '00000000000' + value;
      const formattedNumber = (tempString).substring((tempString.length - amountOfDigits));
      return formattedNumber;
    }
    return '000000';
  }
}
